import { get } from "lodash";

export const summarizeRates = (prices) => {
  const rates = get(prices, "rates") || {};
  const publicAmounts = Object.entries(rates)
    .filter(([key]) => !String(key).includes("|"))
    .map(([, amount]) => Number(amount))
    .filter((amount) => !Number.isNaN(amount));
  if (publicAmounts.length === 0) {
    return null;
  }
  return {
    min: Math.min(...publicAmounts),
    max: Math.max(...publicAmounts),
  };
};
